module.exports = __webpack_public_path__ + "img/google-play-badge.a0a26a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/google-play-badge.png
// module id = x7C+
// module chunks = 3 5